import { getPrefilledSignupData } from '../flow-settings/settingsSelectors';
import { bulkUpdate, prefillDataStored, stampPrefilled } from '../store/signup-data/action-creators';
export const prefillSignupDataFromUrl = () => dispatch => {
  const prefills = getPrefilledSignupData();
  const dataIsPopulated = Object.keys(prefills).length !== 0;

  if (dataIsPopulated) {
    dispatch(bulkUpdate(prefills));
    dispatch(stampPrefilled(prefills));
    dispatch(prefillDataStored());
  }
};